import { c as _c } from "react/compiler-runtime";
import { AnimatePresence, motion } from "framer-motion";
import RepCategorySearchItem from "./RepCategorySearchItem";
export default function RepCategorySearchDropdown(t0) {
  const $ = _c(11);
  const {
    open,
    categories,
    selected,
    disabledCategories: t1,
    onSelect
  } = t0;
  let t2;
  if ($[0] !== t1) {
    t2 = t1 === undefined ? [] : t1;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const disabledCategories = t2;
  const noResultsText = !selected || selected.length < 3 ? "Type at least 3 characters" : "No results";
  let t3;
  if ($[2] !== categories || $[3] !== disabledCategories || $[4] !== noResultsText || $[5] !== onSelect || $[6] !== open || $[7] !== selected) {
    t3 = open && <motion.div className="tw-absolute tw-z-10 tw-mt-1.5 tw-w-full tw-rounded-lg tw-shadow-xl tw-bg-iron-800 tw-ring-1 tw-ring-black tw-ring-opacity-5" initial={{
      opacity: 0,
      y: -20
    }} animate={{
      opacity: 1,
      y: 0
    }} exit={{
      opacity: 0,
      y: -20
    }} transition={{
      duration: 0.2
    }}><div className="tw-absolute tw-z-10 tw-overflow-hidden tw-w-full tw-rounded-md tw-bg-iron-800 tw-shadow-2xl tw-ring-1 tw-ring-white/10"><div className="tw-py-1 tw-flow-root tw-overflow-x-hidden tw-overflow-y-auto"><ul className="tw-flex tw-flex-col tw-px-2 tw-mx-0 tw-mb-0 tw-list-none">{categories.length ? categories.map(category => <RepCategorySearchItem key={category} category={category} selected={selected} disabledCategories={disabledCategories} onSelect={onSelect} />) : <li className="tw-py-2 tw-w-full tw-h-full tw-flex tw-items-center tw-justify-between tw-text-sm tw-font-medium tw-text-white tw-rounded-lg tw-relative tw-select-none tw-px-2">{noResultsText}</li>}</ul></div></div></motion.div>;
    $[2] = categories;
    $[3] = disabledCategories;
    $[4] = noResultsText;
    $[5] = onSelect;
    $[6] = open;
    $[7] = selected;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== t3) {
    t4 = <AnimatePresence mode="wait" initial={false}>{t3}</AnimatePresence>;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
}